import dayjs from 'dayjs';

/**
 * Default values for slot creation form
 */
export const DEFAULT_SLOT_VALUES = {
  startTime: '09:00',
  durationMinutes: 30,
  capacity: 1,
  selectedTaskIds: {},
  eventKindId: '',
};

/**
 * Form field configurations
 */
export const FORM_FIELD_CONFIG = {
  timeInput: {
    width: 80,
    size: 'xs',
  },
  /** Native HTML date input (locale display; value stays YYYY-MM-DD) */
  dateInput: {
    width: 150,
    size: 'xs',
  },
  duration: {
    width: 80,
    size: 'xs',
    readonly: true,
  },
  capacity: {
    width: 80,
    size: 'xs',
  },
  eventKind: {
    width: 180,
    size: 'xs',
  },
};

/**
 * Time-related constants
 */
export const TIME_CONSTANTS = {
  DEFAULT_START_HOUR: 9,
  SLOT_GAP_MINUTES: 10,
  MIN_FUTURE_HOURS: 1, // Minimum hours in the future for slot creation

  // Polling intervals for different scenarios
  // Note: Student booking status polling is handled directly in useEventTaskSlots:
  // - 5s when booking status is 'pending' (waiting for email confirmation)
  // - 30s when booking status is 'confirmed' (normal monitoring)
  // - 2min for slot availability (less critical)
  LECTURER_BOOKING_POLL_INTERVAL: 10000, // 10s - Lecturers monitoring slot bookings
  CLIPBOARD_RESET_DELAY: 2000,
};

/**
 * Validation function to check if start time is at least 1 hour in the future
 */
export const validateFutureTime = (timeValue, selectedDate) => {
  if (!timeValue || !selectedDate) return true;

  const [hours, minutes] = timeValue.split(':').map(Number);
  const proposedDateTime = dayjs(selectedDate).hour(hours).minute(minutes).second(0)
    .millisecond(0);

  const minFutureTime = dayjs().add(TIME_CONSTANTS.MIN_FUTURE_HOURS, 'hour');

  if (proposedDateTime.isBefore(minFutureTime)) {
    return `Time must be at least ${TIME_CONSTANTS.MIN_FUTURE_HOURS} hour in the future`;
  }

  return true;
};

/**
 * Form validation rules
 */
export const VALIDATION_RULES = {
  eventKind: {
    required: 'Event Kind is required',
  },
  startTime: {
    required: true,
    pattern: {
      value: /^([01]\d|2[0-3]):([0-5]\d)$/,
      message: 'HH:mm',
    },
  },
};
